<template>
  <WCForm
    :form="$v.form"
    @update:value="$emit('form-changed', $event)"
    @update:valid="$emit('update:valid', $event)"
  >
    <WCFormGroup class="w-100" :field="$v.form.street1">
      <WCLabel for="identity-form__street1">{{ $t('streetAddress1') }}</WCLabel>
      <WCInput
        class="bg-light"
        id="identity-form__street1"
        name="address"
        autocomplete="address-line1"
      />
      <WCValidationErrors />
    </WCFormGroup>

    <WCFormGroup class="w-100" :field="$v.form.street2">
      <WCLabel for="identity-form__street2">{{ $t('streetAddress2') }}</WCLabel>
      <WCInput
        class="bg-light"
        id="identity-form__street2"
        name="address"
        autocomplete="address-line2"
      />
      <WCValidationErrors />
    </WCFormGroup>

    <div class="d-flex justify-content-between">
      <WCFormGroup class="wc-input" :field="$v.form.city">
        <WCLabel for="identity-form__city">{{ $t('city') }}</WCLabel>
        <WCInput
          class="bg-light"
          id="identity-form__city"
          name="city"
          autocomplete="address-level2"
        />
        <WCValidationErrors />
      </WCFormGroup>

      <WCFormGroup class="wc-input" :field="$v.form.postal">
        <WCLabel for="identity-form__postal">{{ $t('zipCode') }}</WCLabel>
        <WCInput
          class="bg-light"
          id="identity-form__postal"
          name="postal"
          autocomplete="postal-code"
        />
        <WCValidationErrors />
      </WCFormGroup>
    </div>

    <div class="d-flex justify-content-between">
      <WCFormGroup class="wc-input" :field="$v.form.state">
        <WCLabel for="identity-form__state">{{ $t('state') }}</WCLabel>
        <WCSelect
          id="identity-form__state"
          class="bg-light"
          name="state"
          autocomplete="address-level1"
        >
          <option value="">{{ $t('selectState') }}</option>
          <option v-for="s in sortedStateOptions" :key="s.id" :value="s.id">{{
            s.description
          }}</option>
        </WCSelect>
        <WCValidationErrors />
      </WCFormGroup>

      <WCFormGroup class="wc-input" :field="$v.form.country">
        <WCLabel for="identity-form__country">{{ $t('country') }}</WCLabel>
        <WCSelect
          class="bg-light"
          id="identity-form__country"
          name="country"
          autocomplete="country-name"
        >
          <option value="">{{ $t('selectCountry') }}</option>
          <option :value="getUSAOption[0].id" v-if="getUSAOption.length > 0">{{
            getUSAOption[0].description
          }}</option>
          <option v-for="c in sortedCountriesOptions" :key="c.id" :value="c.id">{{
            c.description
          }}</option>
        </WCSelect>
        <WCValidationErrors />
      </WCFormGroup>
    </div>
  </WCForm>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import WCForm from '@/modules/forms/components/WCForm/WCForm.vue';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCSelect from '@/modules/forms/components/WCSelect/WCSelect.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import { dynamicSort } from '@/utils';

export default {
  components: {
    WCFormGroup,
    WCSelect,
    WCValidationErrors,
    WCLabel,
    WCForm,
    WCInput,
  },
  props: {
    shipping: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        street1: this.shipping.street1 || '',
        street2: this.shipping.street2 || '',
        country: this.shipping.country || this.$configuration.defaultCountry,
        postal: this.shipping.postal || '',
        city: this.shipping.city || '',
        state: this.shipping.state || this.$configuration.defaultState,
      },
    };
  },
  computed: {
    /**
     * Sort state options in ascending order
     */
    sortedStateOptions() {
      return dynamicSort(this.$configuration.states, 'description');
    },
    /**
     * Sort countries options in ascending order
     */
    sortedCountriesOptions() {
      return dynamicSort(this.$configuration.countries, 'description');
    },
    /**
     * For country options, US will be the first one
     */
    getUSAOption() {
      return this.$configuration.countries.filter(el => el.description === 'United States');
    },
  },
  validations: {
    form: {
      street1: {
        required,
      },
      street2: {},
      country: {
        required,
      },
      postal: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.wc-input {
  width: 45%;
}
</style>
